// 在线统计账号数据online_account
import request from '@/utils/request';
export function onlineAccounts(data) {
  return request({
    url: '/data/online_account',
    method: 'get',
    params: data
  });
}